
<template>
  <div class="onboarding-page">
    <accountCreated></accountCreated>
  </div>
</template>

<script>
import accountCreated from '@/components/onboarding/accountCreated';

export default {
  components: {
    accountCreated,
  },
};
</script>

<style lang="scss" scoped>
</style>
